import { createNamespacedAction } from "app/pages/sales-intelligence/store/utils";

const createTeamsAction = createNamespacedAction("si/teams");

export const setTerritoryEnabled = createTeamsAction<boolean>("set-territory-enabled");

export const setSelectedTeamId = createTeamsAction<number | null>("set-selected-team-id");

export const resetTerritory = createTeamsAction("reset-territory");
